import CheckboxButtonGroup from "../../Control/Button/CheckboxButtonGroup";
import { Label } from "../../Label/Label";
import { forwardRef } from "react";
import StringInput from "../../Control/InputBox/StringInput";
import RadioButtonGroup from "../../Control/Button/RadioButtonGroup";
import { ItemDisplayModalBodyProps } from "../types";
import Toggle from "../../Toggle/Toggle";
import { ProductFilterState } from "./types";
import { ProductTypeSelector } from "../../Filters/Product/ProductTypeSelector";
import { SortBySelector } from "../../Filters/Product/SortBySelector";
import { TextSelector } from "../../Filters/Product/TextSelector";
import { BooleanSelector } from "../../Filters/BooleanSelector";

export type ProductFilterModalBodyProps = ItemDisplayModalBodyProps<ProductFilterState> & {
    showOptionalFilters?: boolean,
    showVariantTypeFilter?: boolean,
    collection?: Record<string, number>
}

const ProductFilterModalBody = forwardRef<HTMLDivElement, ProductFilterModalBodyProps>(
    (props, ref) => {
        return (
            <>
                <TextSelector
                    value={props.currentFilterState.searchText}
                    update={(value) => props.updateState((copy) => copy.searchText = value)} />

                <ProductTypeSelector
                    values={props.currentFilterState.productTypeState}
                    update={(values) => props.updateState((copy) => copy.productTypeState = values)} />

                <SortBySelector
                    defaultSortOptions={"Release Date (Desc)"}
                    value={props.currentFilterState.sortByState}
                    update={(values) => props.updateState((copy) => copy.sortByState = values)} />

                <BooleanSelector
                    label="Purchaseable Only"
                    value={props.currentFilterState.generalAvailabilityOnly}
                    update={(value) => props.updateState((copy) => copy.generalAvailabilityOnly = value)} />
            </>
        )
    }
);

export default ProductFilterModalBody;